import axios from 'axios';
import appConfig from 'src/config';

class AxiosServices {

    static baseURL: string = appConfig.apiURL;

    // }/account/check-email?token=${token}`;

    static validateToken(token: string) {

    }

    static getUsers(callback: Function) {
        axios.get("https://jsonplaceholder.typicode.com/users").then((data) => {
            console.log(data);
            callback(data?.data);
        });
    }

    static RegisterAccount(values: any) {
        const baseURL = `${this.baseURL}/account/register`;
        return axios.post(baseURL, values);
    }

    static AccountLogin(values: any) {
        const baseURL = `${appConfig.apiURL}/account/login`;
        return axios.post(baseURL, values)
    }

    static async ValidateEmail(token: string) {
        const baseURL = `${appConfig.apiURL}/account/check-email?token=${token}`;
        const res = await axios.get(baseURL);
        console.log(res);
        return res;
    }
}

export default AxiosServices;
